/**
 * @generated SignedSource<<eda13d71a30b78392ee189cc97e9512a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InvoiceStatus = "applied" | "unapplied" | "unset";
export type UpdateInfluencerInfoMutationInput = {
  birthday?: string | null;
  clientMutationId?: string | null;
  commonName?: string | null;
  gender?: string | null;
  invoiceNo?: string | null;
  invoiceStatus?: InvoiceStatus | null;
  profile?: string | null;
  tiktokUrl?: string | null;
  twitterUrl?: string | null;
  ytChannel?: string | null;
};
export type CampaignInputSnsMutation$variables = {
  input: UpdateInfluencerInfoMutationInput;
};
export type CampaignInputSnsMutation$data = {
  readonly updateInfluencerInfo: {
    readonly __typename: "Influencer";
    readonly profile: {
      readonly tiktokUrl: string | null;
      readonly ytChannel: string | null;
    };
  } | {
    readonly __typename: "UpdateInfluencerInfoError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type CampaignInputSnsMutation = {
  response: CampaignInputSnsMutation$data;
  variables: CampaignInputSnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tiktokUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ytChannel",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdateInfluencerInfoError",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignInputSnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignInputSnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "564225931ab69f9030a40a9c4e051945",
    "id": null,
    "metadata": {},
    "name": "CampaignInputSnsMutation",
    "operationKind": "mutation",
    "text": "mutation CampaignInputSnsMutation(\n  $input: UpdateInfluencerInfoMutationInput!\n) {\n  updateInfluencerInfo(input: $input) {\n    __typename\n    ... on Influencer {\n      profile {\n        tiktokUrl\n        ytChannel\n        id\n      }\n      id\n    }\n    ... on UpdateInfluencerInfoError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aa408de01e25064e5d33ecd943fa2c5";

export default node;
